import * as types from './mutation-types';

export default {
  [types.SET_TOGGLE_MODAL_DELETE_SERVICE_TRIBUTES](state) {
    state.modalDeleteServiceTributesIsOpen = !state.modalDeleteServiceTributesIsOpen;
  },
  [types.SET_MODAL_DELETE_SERVICE_TRIBUTES_IDS](state, payload) {
    state.modalDeleteServiceTributesIds = payload;
  },
};
